<template>
    <div>
        <div class="sf2__title--left-stroke title--xs">Sei residente nella casa <strong>dove attiverai la fornitura?</strong></div>

        <radioBox class="small-label column" :question="resident.question" :items="resident.items" :default="resident.current"  @changed="onResidentChange" />
        
        <div :class="{ hide: commodity=='gas' }">
            <div class="form-label">Inserisci il CAP</div>
            <input type="text" name="cap" placeholder="Scrivi il tuo CAP" maxlength="5" @keypress="checkCap($event)" v-model="zip">
        </div>
        
        <div class="lock-down">
            <button class="sf2-btn" @click="next()">Continua</button>
        </div>
    </div>
</template>

<script>

    import RadioBox from '../../../elements/RadioBox.vue';
    import Zip from '../../Helpers/Zip.js';

    export default {
        name: "Residenza",
        components: {
            RadioBox
        },
        props: {
        },
        data() {
            return {
                commodity: 'luce',
                zip: '',
                resident: {
                    question: "Residenza",
                    current: "residente",
                    isResident: true,
                    items: [
                        { 
                            "label": "sono residente",
                            "value": "residente",
                            "class": ""
                        }, {
                            "label": "non sono residente",
                            "value": "non residente",
                            "class": ""
                        }
                    ]
                }
            };
        },
        mounted() {
            console.log('Residenza mounted');

            this.zipService = Zip;
        },
        computed: {

        },
        methods: {
            onResidentChange( resident ) {
                console.log( 'Consumption onResidentChange resident', resident.val );

                this.resident.isResident = resident.val == "residente";
            },

            checkCap( evt ) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                }

                if (this.zip.length == 2){
                    if ( this.zipService.getRegion( this.zip  ) ){
                        // 
                    } else {
                        this.zip = '';
                    }
                }
            },

            next() {
                console.log( 'Residenza emit onNext' );

                this.$emit( 'onNext', {
                    'zip': this.zip,
                    'resident': this.resident.isResident
                } );
            },

            back() {
                console.log( 'Residenza emit onBack' );

                this.$emit( 'onBack', 1 );
            }
        },
    };
</script>

<style scoped lang="scss">

    .sf2__title--left-stroke { margin-bottom: 30px; }

    button {margin-top: 30px;}

</style>